import React from 'react';
import { ExternalLinkIcon } from 'react-line-awesome';
import { useStyletron } from 'baseui';
import { Heading, HeadingLevel } from 'baseui/heading';
import { nanoid } from 'nanoid';
import { ROUTES } from '@gtintel/platform-constants';
import { ProjectContext } from '../../ProjectApp/context';
import { StatusDisplay } from '../StatusDisplay';
export default () => {
  const [css] = useStyletron();
  const {
    subprojects
  } = React.useContext(ProjectContext);
  return <section className={css({
    display: 'flex',
    flexFlow: 'column',
    marginBottom: '32px',
    gap: '4px'
  })} data-testid="subprojects-list">
      <HeadingLevel>
        <Heading styleLevel={4}>Sub-Projects</Heading>
      </HeadingLevel>
      {subprojects().map(project => <a href={`${ROUTES.ADMIN_PROJECT_DETAIL}/${project.id}`} target="_blank" rel="noreferrer" key={nanoid()} className={css({
      alignItems: 'center',
      display: 'flex',
      flexFlow: 'row',
      gap: '8px',
      justifyContent: 'space-between',
      padding: '8px 16px',
      textWrap: 'wrap',
      transition: 'background-color 0.3s ease',
      wordWrap: 'break-word',
      p: {
        margin: 0
      },
      ':hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.05)',
        transition: 'background-color 0.3s ease'
      },
      '@media only screen and (max-width: 768px)': {
        flexFlow: 'column'
      }
    })}>
          <p>{project.name}</p>
          <StatusDisplay status={project.status} />
          <ExternalLinkIcon />
        </a>)}
    </section>;
};